<template>
<div class="page">
	
</div>
</template>

<script>
  export default {
    name: 'nav-footer',
    data(){
      return{}
    },
    mounted() {
    },
	created(){},
    methods: {}
  }
</script>

<style lang="scss" scoped>
	.page{
		width: 220px;
		height: 100vh;
		background: #fff;
		text-align: center;
		padding: 14px 0 0 0;
		border-right: 1px solid #EEEEEE;
	}
	
</style>